<template>
  <div>
    <common-table ref="table" :table-columns="tableColumns" :url="url" :operate="operate" :searchs="searchs"
      :form-fields="formFields" :permission="permission" pageName="QianchuanTaskLog" />
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";

export default {
  name: 'QianchuanTaskLog',
  components: { CommonTable },
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll', // 复用代理选择接口
        selectData: [],
      }, {
        name: 'groupId',
        placeholder: '账户分组',
        type: 'select',
        selectUrl: '/oceanEngineAdvertiserGroup/getAll',
        selectData: [],
      }, {
        name: 'advertiserId',
        placeholder: '广告主',
        type: 'select',
        selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
        valueKey: 'advertiserId',
        selectData: [],
      }, {
        name: 'status',
        placeholder: '状态',
        type: 'select',
        selectValue: [{
          key: 0,
          value: '成功',
        }, {
          key: 1,
          value: '失败',
        },]
      }, {
        name: 'startTime',
        placeholder: '执行开始时间',
        type: 'dateTime',
      }, {
        name: 'endTime',
        placeholder: '执行结束时间',
        type: 'dateTime',
      },],
      permission: {
        add: 'qianchuanTaskLog:add',
        update: 'qianchuanTaskLog:update',
        delete: 'qianchuanTaskLog:delete',
        deleteBatch: 'qianchuanTaskLog:deleteBatch'
      },
      url: {
        get: '/qianchuanTaskLog/listByCondition',
        add: '/qianchuanTaskLog/add',
        update: '/qianchuanTaskLog/update',
        delete: '/qianchuanTaskLog/delete',
        delete_batch: '/qianchuanTaskLog/deleteBatch',
        status: '/qianchuanTaskLog/status',
      },
      tableColumns: [{
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
      },
      {
        field: 'taskId',
        label: '任务ID',
        sort: false,
        show: true,
      }, {
        field: 'taskName',
        label: '任务名称',
        sort: false,
        show: true,
      }, {
        field: 'advertiserName',
        label: '广告主',
        sort: false,
        show: true,
      }, {
        field: 'planName',
        label: '计划名称',
        sort: false,
        show: true,
      }, {
        field: 'roi',
        label: 'ROI值',
        sort: false,
        show: true,
        formatter: (row) => row.roi ? row.roi.toFixed(2) : '-'
      }, {
        field: 'suggestRoiThreshold',
        label: '建议ROI阈值',
        sort: false,
        show: true,
      }, {
        field: 'suggestRoi',
        label: '建议ROI',
        sort: false,
        show: true,
      }, {
        field: 'dailyBudget',
        label: '日预算(元)',
        sort: false,
        show: true,
        formatter: (row) => row.dailyBudget ? row.dailyBudget.toFixed(2) : '-'
      }, {
        field: 'executeTime',
        label: '执行时间',
        sort: false,
        show: true,
      }, {
        field: 'status',
        label: '执行状态',
        sort: false,
        show: {
          type: 'tag',
          tags: [
            { key: 0, value: '成功', type: 'success' },
            { key: 1, value: '失败', type: 'danger' },
            { key: 2, value: '重试中', type: 'info' }
          ]
        },
      }, {
        field: 'remark',
        label: '异常备注',
        sort: false,
        show: true,
        formatter: (row) => row.remark || '-',
      }, {
        field: 'createTime',
        label: '创建时间',
        show: true,
        width: '',
      }
      ],
      formFields: {
        addTitle: '添加日志',
        updateTitle: '修改日志',
        model: [{
          field: 'taskId',
          label: '任务ID：',
          type: 'input',
          placeholder: '请输入任务ID',
          rules: [{ required: true, message: '任务ID不能为空', trigger: 'blur' }],
          add: true,
          update: true,
        },
        {
          field: 'taskName',
          label: '任务名称：',
          type: 'input',
          placeholder: '请输入任务名称',
          rules: [
            { required: true, message: '任务名称不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'accountId',
          label: '千川账户ID：',
          type: 'input',
          placeholder: '请输入千川账户ID',
          rules: [{ required: true, message: '千川账户ID不能为空', trigger: 'blur' }],
          add: true,
          update: true,
        }, {
          field: 'planName',
          label: '计划名称：',
          type: 'input',
          placeholder: '请输入计划名称',
          rules: [
            { required: false, message: '计划名称不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'roi',
          label: 'ROI值：',
          type: 'input',
          placeholder: '请输入ROI值',
          rules: [
            { required: false, message: 'ROI值不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'dailyBudget',
          label: '日预算(元)：',
          type: 'input',
          placeholder: '请输入日预算',
          rules: [
            { required: false, message: '日预算不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        },
        {
          field: 'executeTime',
          label: '执行时间：',
          type: 'dateTime',
          placeholder: '请选择执行时间',
          rules: [
            { required: true, message: '执行时间不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }, {
          field: 'status',
          label: '执行状态：',
          type: 'select',
          placeholder: '请选择执行状态',
          rules: [
            { required: true, message: '执行状态不能为空', trigger: 'blur' }
          ],
          selectData: [{
            id: 0,
            name: '成功'
          }, {
            id: 1,
            name: '失败'
          }],
          add: true,
          update: true,
        }, {
          field: 'remark',
          label: '异常备注：',
          type: 'input',
          placeholder: '请输入异常备注（失败时必填）',
          rules: [
            { required: false, message: '异常备注不能为空', trigger: 'blur' }
          ],
          add: true,
          update: true,
        }
        ]
      },
      operate: [
        {
          icon: 'el-icon-edit',
          type: 'text',
          text: '重试创建计划',
          exist2: true,
          handle: (row) => {
            console.log(row)
            if (row.remark.includes('商品Id')) {
              this.$axios.get({
                url: '/qianchuanScheduleTask/retryTask/' + row.id,
                success: (res) => {
                  // this.loading = false
                  console.log('333', res)
                  if (res.code == 0) {
                    this.$message.success('重试成功')
                    // this.showAddCreateRulePopup = false
                    this.$refs.table.getData()
                  } else {
                    this.$message.error(res.msg || '出错了')
                  }
                },
                error: () => {
                  this.loading = false
                  this.$message.error('出错了')
                },
              })
            } else {
              this.$message.error('该计划异常备注不包括商品id，无法重试')
            }

            // this.resetPwdForm.id = row.id;
            // this.resetPwdForm.username = row.username;
            // this.resetPwdVisible = true;
          }
        }, {
          icon: 'el-icon-edit',
          type: 'text',
          text: '刷新状态',
          handle: (row) => {
            console.log(row)
            this.$refs.table.getData()

            // this.resetPwdForm.id = row.id;
            // this.resetPwdForm.username = row.username;
            // this.resetPwdVisible = true;
          }
        },
      ]
    }
  }
}
</script>

<style scoped></style>
